import { Button, ButtonProps } from "antd";
import { FC } from "react";

interface OrderSummaryButtonProps extends ButtonProps {
  onClick: () => void;
}

const OrderSummaryButton: FC<OrderSummaryButtonProps> = ({
  onClick,
  className = "",
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      className={`mb-2 md:mb-0 ${className}`}
      size="large"
      type="primary"
      {...props}
    >
      สรุปรายการสั่งซื้อ
    </Button>
  );
};

export default OrderSummaryButton;
